// src/constants/errors.ts
export const ERROR_CODES = {
  NETWORK_ERROR: 'NETWORK_ERROR',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  NOT_FOUND: 'NOT_FOUND',
  UNAUTHORIZED: 'UNAUTHORIZED',
  FORBIDDEN: 'FORBIDDEN',
  SERVER_ERROR: 'SERVER_ERROR',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR'
} as const;

// Ключи переводов для сообщений об ошибках
export const ERROR_TRANSLATION_KEYS = {
  [ERROR_CODES.NETWORK_ERROR]: 'errors.network',
  [ERROR_CODES.VALIDATION_ERROR]: 'errors.validation',
  [ERROR_CODES.NOT_FOUND]: 'errors.not_found',
  [ERROR_CODES.UNAUTHORIZED]: 'errors.unauthorized',
  [ERROR_CODES.FORBIDDEN]: 'errors.forbidden',
  [ERROR_CODES.SERVER_ERROR]: 'errors.server',
  [ERROR_CODES.UNKNOWN_ERROR]: 'errors.unknown'
} as const;

// Сохраняем для обратной совместимости
export const ERROR_MESSAGES = {
  [ERROR_CODES.NETWORK_ERROR]: 'Network connection error occurred',
  [ERROR_CODES.VALIDATION_ERROR]: 'Validation error occurred',
  [ERROR_CODES.NOT_FOUND]: 'Requested resource not found',
  [ERROR_CODES.UNAUTHORIZED]: 'Authentication required',
  [ERROR_CODES.FORBIDDEN]: 'Access denied',
  [ERROR_CODES.SERVER_ERROR]: 'Server error occurred',
  [ERROR_CODES.UNKNOWN_ERROR]: 'An unexpected error occurred'
} as const;